<template>
    <div :class="[ 'table', { 'table--margin': !settings.removeMargin } ]" aria-label="table">
        <div class="table__header" role="rowgroup">
            <div class="table__header__row" role="row">
                <column-header
                    v-for="( header, index ) in headers"
                    :header="header"
                    class="table__header__row__text display--inline-b capitalize"
                    :class="`table__${model}__col__${index}`"
                    :key="index"
                />
            </div>
        </div>
        <div class="table__body scroll" role="rowgroup">
            <component
                :is="component"
                v-for="row in list"
                :class="[
                    'table__body__row display--flex',
                    'table__body__row--color'
                ]"
                :headers="headers"
                :row="row"
                :model="model"
                :key="row.uuid || row.id"
                v-bind="{
                    ...( settings.action && { action: settings.action } )
                }"
            />
        </div>
    </div>
</template>

<script>
export default {
    components: {
        ColumnHeader: () => import( /* webpackChunkName: 'ColumnHeader' */ '@/components/bundles/tables/packs/ColumnHeader' )
    },
    props: {
        headers: Array,
        list: Array,
        model: String,
        settings: Object
    },
    setup ( props ) {
        const component = () => import( /* webpackChunkName: 'Row-[request]' */ `@/components/dynamic/rows/${props.settings.component}` );

        return { component };
    }
};
</script>
<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $columns-clients: ( '0': 20%, '1': 15%, '2': 40%, '3': 25% );
    $columns-fees: ( '0': 30%, '1': 40%, '2': 30% );

    // =============================================================================
    // Styles
    // =============================================================================
    .table {
        margin: 15px;
        &--without-results {
            padding: $card-spacing;
        }
        &__header {
            &__row {
                @include typography-specs( 16px, 22px, 500 );
                color: $color-black;
                padding: 0 30px 0;
            }
        }
        &__body {
            max-height: var( --max-height );
            margin-top: 15px;
            overflow-x: auto;
            &__row {
                align-items: center;
                height: 60px;
                padding: 0 30px 0;
                @include rounded-corner( 5px );
                &:hover {
                    background: $color-grey-light;
                }
                &__text {
                    @include typography-specs( 15px, 20px, 500 );
                    padding-right: 10px;
                    &__svg {
                        margin-left: 10px;
                    }
                    &__tooltip {
                        @include transform-position( 1px, false, false, -96px, translateX( -50% ) );
                        width: max-content;
                    }
                }
            }
            &__row:not(:last-child) {
                border-bottom: 1px solid #E5EFFF;
            }
        }
        &__client {
            &__col {
                @each $index,
                $width in $columns-clients {
                    &__#{$index} {
                        text-transform: capitalize;
                        width: $width;
                    }
                }
            }
        }
        &__fee {
            &__col {
                @each $index,
                $width in $columns-fees {
                    &__#{$index} {
                        text-transform: capitalize;
                        width: $width;
                    }
                }
            }
        }
        &--margin {
            margin-top: $card-space-between-header-body;
        }
    }
</style>